module.exports = __webpack_public_path__ + "img/CAL-IEC-S.1b9d0821.png";